import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import DiscoverSkeleton from "./DiscoverSkeleton";

function Box({ children }) {
  return (
    <div
      style={{
        display: "block",
        lineHeight: 1,
        marginBottom: "8px",
        width: "100%",
      }}
    >
      {children}
    </div>
  );
}

const MainTextSkeleton = ({ isEventPage, isDesktop }) => {
  const md = useMediaQuery("(max-width: 768px)");
  const containerStyle = {
    padding: "0 16px",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: md ? "column" : "row",
  };

  const descriptionStyle = {
    width: md ? "100%" : "789px",
  };

  const castStyle = {
    width: md ? "100%" : "357px",
    padding: md ? "0" : "16px",
    marginLeft: md ? "0" : "24px",
    marginTop: md ? "8px" : "0",
  };

  return (
    <>
      <div style={containerStyle}>
        <div style={descriptionStyle}>
          <SkeletonTheme
            baseColor="#D8DBE0"
            highlightColor="#EDF1F6"
            borderRadius={"4px"}
          >
            {!isEventPage && (
              <div style={{ marginBottom: "24px" }}>
                <Skeleton wrapper={Box} width={124} height={16} />
              </div>
            )}
            <Skeleton wrapper={Box} count={18} height={16} />
          </SkeletonTheme>
        </div>
        {isEventPage && (
          <div style={castStyle}>
            <SkeletonTheme
              baseColor="#D8DBE0"
              highlightColor="#EDF1F6"
              borderRadius={"4px"}
            >
              {md ? (
                <div style={{ marginBottom: "0" }}>
                  <Skeleton wrapper={Box} height={31} width={"100%"} />{" "}
                </div>
              ) : (
                <>
                  <div style={{ marginBottom: "13px" }}>
                    <Skeleton wrapper={Box} height={31} width={"45%"} />
                  </div>
                  <div style={{ marginBottom: "13px" }}>
                    <Skeleton
                      wrapper={Box}
                      count={2}
                      height={16}
                      width={"80%"}
                    />
                  </div>
                  <div style={{ marginBottom: "13px" }}>
                    <Skeleton
                      wrapper={Box}
                      count={2}
                      height={16}
                      width={"80%"}
                    />
                  </div>
                  <div style={{ marginBottom: "13px" }}>
                    <Skeleton
                      wrapper={Box}
                      count={2}
                      height={16}
                      width={"80%"}
                    />
                  </div>
                  <div style={{ marginBottom: "13px" }}>
                    <Skeleton
                      wrapper={Box}
                      count={2}
                      height={16}
                      width={"80%"}
                    />
                  </div>
                  <div style={{ marginBottom: "13px" }}>
                    <Skeleton
                      wrapper={Box}
                      count={2}
                      height={16}
                      width={"80%"}
                    />
                  </div>
                </>
              )}
            </SkeletonTheme>
          </div>
        )}
        {!isEventPage && isDesktop && (
          <DiscoverSkeleton isDesktop={isDesktop} />
        )}
      </div>
    </>
  );
};

export default MainTextSkeleton;
